export default "__VITE_ASSET__CFaTAXxI__"